import getDefaultSettings from './getDefaultSettings';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import saveDefaultSettings from './services/saveDefaultSettings';
import updateDefaultSettings from './actions/updateDefaultSettings';
export default function initialize() {
    var defaultSettings = getDefaultSettings(getUserConfiguration());
    if (defaultSettings) {
        updateDefaultSettings(defaultSettings);
        saveDefaultSettings();
    }
}
//# sourceMappingURL=initialize.js.map